import React, { useState, useEffect } from "react";
import { SubmitReward, GetReward, ShowData } from "../Components/Services";
import Loading from "../../../../Common/Components/Loading";

function Index() {
  const [state, setState] = useState({
    loading: true,
    data: null,
  });

  const handler = data => {
    SubmitReward(data).then(() => getData());
  };
  const getData = () => {
    setState({ loading: true });
    GetReward().then(data => {
      setState({ loading: false, data: data });
    });
  };

  useEffect(() => {
    getData();
  }, []);
  return (
    <div>
      <div className="card">
        <div className="card-body">
          <div className="h2">تنظیمات پاداش</div>
          {state.loading ? (
            <Loading count={1} col={12} height={300} />
          ) : (
            <TextInput
              form={[
                {
                  id: 1,
                  text: "هدیه اولین رزرو",
                  amount: "تومان",
                  value:
                    !state.loading &&
                    ShowData(state.data, "firstreserve_price"),
                  key: "firstreserve_price",
                },
                {
                  id: 3,
                  text: "تعداد حق دعوت",
                  amount: "تعداد",
                  value: !state.loading && ShowData(state.data, "suminvate"),
                  key: "suminvate",
                },
                {
                  id: 2,
                  text: "هدیه دعوت از دوستان",
                  amount: "تومان",
                  value: !state.loading && ShowData(state.data, "invateprice"),
                  key: "invateprice",
                },
              ]}
              method={handler}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default Index;

const TextInput = ({ form, method }) => {
  const [state, setstate] = useState();
  const [elemnts, setElemnts] = useState([...form]);

  const handler = id => {
    let newElements = [...elemnts].map(item => {
      if (item.id == id) {
        item.edit = true;
        return item;
      } else {
      }
      return item;
    });
    setElemnts(newElements);
  };

  useEffect(() => {
    checkEmpty();
  }, []);

  const checkEmpty = () => {
    let newState = {};
    elemnts.map(element => {
      newState[element.key] = element.value;
    });
    setstate({ ...state, ...newState });
  };

  return (
    <div>
      {elemnts.map((element, key) => (
        <div
          key={key}
          className="d-flex p-2 my-3 rounded justify-content-between align-items-center shadow-sm"
        >
          <p className="p-0 align-self-center m-0">
            {element.text} <span>({element.amount})</span>
          </p>

          <div className="d-flex justify-content-center align-items-center ">
            <button
              className={`btn ${
                !element.edit ? "btn-primary" : "btn-success"
              } mx-1 d-flex align-items-center justify-content-center`}
              onClick={() => handler(element.id)}
            >
              <i className="fas fa-edit"></i>
            </button>
            <input
              type="text"
              dir="ltr"
              className="form-control"
              defaultValue={element.value ? element.value : ""}
              disabled={!element.edit}
              onChange={({ target: { value } }) => {
                setstate({ ...state, [element.key]: value });
              }}
            />
          </div>
        </div>
      ))}
      <div className="d-flex align-items-center justify-content-end mt-3">
        <button className="btn btn-primary" onClick={() => method(state)}>
          ارسال اطلاعات
        </button>
      </div>
    </div>
  );
};
